export function isMisereMode(mode) {
    return mode === 'misere' || mode === 'openMisere';
}
//# sourceMappingURL=types.js.map